import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata"
import SEO from "../components/Seo"
import { Twitter } from "@styled-icons/boxicons-logos/Twitter"
import { Github } from "@styled-icons/boxicons-logos/Github"
import { Behance } from "@styled-icons/boxicons-logos/Behance"
import { LinkedinSquare } from "@styled-icons/boxicons-logos/LinkedinSquare"
import { Codepen } from "@styled-icons/boxicons-logos/Codepen"
import { Tumblr } from "@styled-icons/boxicons-logos/Tumblr"

const About_Title = `mb-12 fluid-text-3xl -mt-14 font-normal sm:font-extralight`
const About_SF = "relative z-10 mb-12 fluid-text-lg  max-w-[25em]"
const About_P = "mb-4 mb-4 fluid-text-base max-w-[34em]"

const AboutPage = props => {
  const {
    twitter,
    github,
    behance,
    linkedin,
    tumblrDesign,
    codepen,
  } = useSiteMetadata()

  return (
    <div className="page-trans mx-auto mb-k3v mt-k5v flex w-k8 flex-row flex-wrap items-baseline sm:w-k8 lg:w-k7 xl:w-k5 xl:pl-0 ">
      <SEO metaTitle="Giulia Nicole Pernice || Design Engineering Portfolio || About" />
      <div className="bio">
        <h1 className={`${About_Title}`}>Giulia Nicole Pernice</h1>
      </div>
      <div className="flex flex-row flex-wrap items-baseline sm:ml-k1 md:ml-k25">
        <p className={`${About_SF}`}>
          Today I set technical direction and standards, build the systems and
          tooling other teams work against, and lead a team across Europe. I
          still build, though, because the moment you lose touch with the craft
          your judgement starts to drift.
        </p>
        <div className={`flex flex-col md:flex-row`}>
          {/* <div className="z-0 w-full mt-8 md:mt-2 sm:w-k6 sm:pl-k2 md:pl-0 md:-ml-k lg:pl-k2 md:w-k4  lg:w-k4 lg:-ml-k0 xl:-ml-k2 order-2 md:order-1">
            <StaticImage
              className=""
              src="https://res.cloudinary.com/yumyo/image/upload/v1640539607/media/about-g.png"
              alt="A kitten"
            />
          </div> */}
          <div className={`order-1 w-full md:order-2 md:w-k75`}>
            <p className={`${About_P}`} data-sal="fade" data-sal-duration={900}>
              My career began with a formal education in graphic design in the
              mid 90s, in print, just as the web was learning to be a visual
              medium rather than a document format, when Flash and CSS were
              pulling layout away from tables.
            </p>
            <p className={`${About_P}`} data-sal="fade" data-sal-duration={900}>
              From paper and ink to pixels, polygons and intelligent systems,
              each medium has opened a new way of thinking. Driven by wanting
              to understand every part of the process, I became a full-stack
              developer and designer with a product mindset. The tools have
              changed, but my curiosity has not: understanding how people
              interact with technology, and how design makes that interaction
              clearer.
            </p>
            <p className={`${About_P}`} data-sal="fade" data-sal-duration={900}>
              I often act as a bridge between stakeholders, teams and business
              units. I believe in open, honest and kind communication, and in
              the power of mentoring and knowledge sharing.
            </p>
            <p className={`${About_P} mb-0`} data-sal="fade" data-sal-duration={900}>
              I also contribute to non-profit initiatives and projects that
              foster innovation and creativity for social change.
            </p>
            <p className={`${About_P}`} data-sal="fade" data-sal-duration={900}>
              AI has not reduced my work, it has expanded it. I write no less
              code, I have just become syntax-independent, which moves my
              attention to intent, abstraction, and the problem I am actually
              trying to solve. I work alongside agents now, and they extend my
              judgement rather than replace it. When the tools are available to
              everyone, what differentiates us is the depth of our ideas and
              the clarity of our vision. This technology does not replace our
              humanity; it highlights the need for it.
            </p>
            <p className={`${About_P}`} data-sal="fade" data-sal-duration={900}>
              We are becoming architects not just of products, but of
              possibility.
            </p>
            <p className={`${About_P} mb-0`} data-sal="fade" data-sal-duration={900}>
              If you’d like to know more about my work, or a glimpse behind the
              scenes, come and find me on my social channels.
            </p>
            <div className="mt-k0v" data-sal="fade" data-sal-duration={900}>
              <ul className="flex flex-row flex-wrap gap-6">
                <li>
                  <a href={linkedin} target="_blank" rel="noreferrer" title="">
                    <LinkedinSquare size="32" />
                  </a>
                </li>
                <li>
                  <a href={github} target="_blank" rel="noreferrer" title="">
                    <Github size="32" />
                  </a>
                </li>
                <li>
                  <a href={codepen} target="_blank" rel="noreferrer" title="">
                    <Codepen size="32" />
                  </a>
                </li>
                <li>
                  <a href={behance} target="_blank" rel="noreferrer" title="">
                    <Behance size="32" />
                  </a>
                </li>
                <li>
                  <a href={twitter} target="_blank" rel="noreferrer" title="">
                    <Twitter size="32" />
                  </a>
                </li>
                <li>
                  <a
                    href={tumblrDesign}
                    target="_blank"
                    rel="noreferrer"
                    title=""
                  >
                    <Tumblr size="32" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutPage
